// 本地缓存数据库

const cache = {
    setStorage: function (keyName, object) {
        
        localStorage.setItem(keyName, JSON.stringify(object));
    },
    getStorage: function (keyName) {
        
        if (localStorage.getItem(keyName)) {
            return JSON.parse(localStorage.getItem(keyName));
        }
        return {};
    },
    removeStorage: function (keyName) {
        
        localStorage.removeItem(keyName);
    },
    clearAll: function () {
        
        localStorage.clear();
    }
};


export default cache;


// WEBPACK FOOTER //
// ./src/store/cache.js